<template lang="html">
  <div
    class="poi-popup"
    :class="css"
    :style="style"
    @click="$f7router.navigate('/poi/' + poi._id)">
    <h2 class="poi-popup-title">{{ poi.title }}</h2>
  </div>
</template>

<script>
export default {
  name: 'PoiPopup',
  props: {
    poi: {
      type: Object,
      required: true
    }
  },
  computed: {
    css () {
      return this.poi.thumb ? 'poi-popup-image' : ''
    },
    style () {
      const backgroundImage = this.poi.thumb ? `url(${this.poi.thumb})` : null
      return backgroundImage ? { backgroundImage } : ''
    }
  }
}
</script>

<style lang="scss">
.poi-popup {
  position: relative;
  cursor: pointer;
  margin: -5px -10px;
  padding: 10px;
  width: 130px;
  border-radius: 5px;
  background-position: center center;
  background-size: cover;
  background-color: #cdbb9f;
  color: white;
  &:before {
    display: block;
    position: absolute;
    content: '';
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 5px;
    z-index: 1;
  }
  .poi-popup-title {
    position: relative;
    margin: 0;
    z-index: 2;
    font-weight: normal;
  }
  &.poi-popup-image {
    height: 150px;
    &:before {
      background: linear-gradient(to bottom, rgba(0,0,0,0) 65%,rgba(0,0,0,0.65) 100%);
    }
    .poi-popup-title {
      position: absolute;
      bottom: 5px;
      left: 10px;
      right: 10px;
    }
  }
}
</style>
